export default {
  api_r_user_global_setError: {
    path: 'global/set-error/',
  },
  api_r_user_global_getLanguages: {
    path: 'global/get-languages/',
  },
  api_r_user_global_getCategories: {
    path: 'global/get-categories/',
  },
  api_r_user_global_getNotes: {
    path: 'global/get-notes/',
  },
  api_r_user_global_getLocations: {
    path: 'global/get-locations/',
  },
  api_r_user_global_getObligationFormTemplates: {
    path: 'global/get-obligation-form-templates/',
  },
  api_r_user_global_getModuleBreadcrumb: {
    path: 'global/get-module-breadcrumb/',
  },
  api_r_user_global_getPlants: {
    path: 'global/get-plants/',
  },
  api_r_user_global_getPlantGroups: {
    path: 'global/get-plant-groups/',
  },
  api_r_user_global_getPlantGroupFolders: {
    path: 'global/get-plant-group-folders/',
  },
  api_r_user_global_getPlantGroupFoldersWithFolderChildren: {
    path: 'global/get-plant-group-folders-with-filder-children/',
  },
  api_r_user_global_getModules: {
    path: 'global/get-modules/',
  },
  api_r_user_global_getStates: {
    path: 'global/get-states/',
  },
  api_r_user_global_changePagination: {
    path: 'global/change-pagination/',
  },
  api_r_user_global_select_plants: {
    path: 'global/select/plants/',
  },
  api_r_user_global_select_user: {
    path: 'global/select/user/',
  },
  api_r_user_global_select_location: {
    path: 'global/select/location/',
  },
  api_r_user_global_select_resourceManagerPeriodTypes: {
    path: 'global/select/rm-period-types/',
  },
  api_r_user_global_session_keep: {
    path: 'global/session/keep/',
  },
  api_r_user_global_permissions_get: {
    path: 'global/permissions/get/',
  },
  api_r_user_global_select_classifiedPlants: {
    path: 'global/select/classified-plants/',
  },
};
